import { Component, OnInit } from '@angular/core';
import { ItemService } from 'app/shared/services/item.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-inventory-balance-report',
  templateUrl: './inventory-balance-report.component.html',
  styleUrls: ['./inventory-balance-report.component.css']
})
export class InventoryBalanceReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  searchKey : string;
  isDark: boolean = false;

  toDate : string;
  category = null;
  itemList : any[]=[];
  categoryList = [];
  filteredItemList : any[]=[];
  itemCategoryList: any[];

  stockBalList:  any[]=[];
  filteredStockBalList : any[]=[];

  
  constructor(
              private itemService : ItemService, 
              private router : Router, 
              private themeService: NbThemeService,
              private decimalPipe: DecimalPipe
             ) {
                 this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

                this.toDate = moment().format("YYYY-MM-DD");
              }

    ngOnInit() {
      this.getAllItems(); 
     this.getItemCategoryList()
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

       
 
  getAllItems(){
    this.itemService.getAll()
     .subscribe(
        (data) => {
                  this.itemList = data;
                  this.filteredItemList =  this.itemList;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getItemCategoryList(){
      this.itemService.getAllItemCategory()
       .subscribe(
          (data) => {
                    this.categoryList = data
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }
  

    viewBtnClicked(){                
  

      }


  
  
       clearBtnClicked(){   
        this.category = null;
        this.searchKey = "";
        this.filteredItemList =  this.itemList;  
       }
  



       applyFilterCategory(event){           
        if(event.selectedIndex==0){
          this.filteredItemList =  this.itemList;  
        }
        else
        {
            this.filteredItemList = this.itemList.filter((el)=>{
            return el.Category.toLowerCase().indexOf(event.value.trim().toLowerCase()) !==-1;          
            }); 
            
 
        }
     }

    applyFilter(){
      this.filteredItemList = this.itemList.filter((el)=>{
         return el.ItemCode.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1 || 
         el.Description.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1;
       });

     }

     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
      
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Inventory Balance Report', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', '*', 'auto','auto','auto'],  
                body: [  
                  ['ItemCode', 'Description','Category','ReorderLevel', 'QtyBal'],
                   ...this.filteredItemList.map(p => ([p.ItemCode,p.Description,p.Category,{ text: p.ReorderLevel,alignment: 'right' },{ text: p.QtyBal,alignment: 'right' }])),                 
                  ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('inventoryBalReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Inventory Balance Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
    }


}
